import { setRouteTemplate } from "@appsignal/browser"

import { tanstackRouter } from "#React/router/routeTree"

// SPA (TanStack) side of the web-vitals route template. The Rails baseline is set
// in appsignal-browser.js, not here — importing the router there would break nav
// (see that file). Imported only from react/start.jsx. See router/README.md.

type RouteMatchInfo = {
  fullPath?: string
  routeId?: string
  globalNotFound?: boolean
  staticData?: { componentName?: string }
}

// Templated client route, or null when the app doesn't own the URL. Besides
// global not-found matches, TanStack can also leave us on a layout-only match for
// Rails-owned descendants (e.g. `/edit` under an app URL). Those layout routes
// carry no `staticData.componentName`, unlike real page routes.
export const spaRouteTemplate = (): string | null => {
  const matches = tanstackRouter.state.matches
  const leaf = matches[matches.length - 1] as RouteMatchInfo | undefined
  if (!leaf || leaf.globalNotFound || !leaf.staticData?.componentName) {
    return null
  }
  return leaf.fullPath ?? leaf.routeId ?? null
}

// Commit the current SPA route; no-op when unowned, so the Rails baseline stays.
export const syncRouteTemplate = (): void => {
  const template = spaRouteTemplate()
  if (template) {
    setRouteTemplate(template)
  }
}
